<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>事项标准管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="事项类型">
                <el-select
                  filterable
                  placeholder="事项类型"
                  clearable
                  v-model="form.ghEventTypeId"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.sxlx"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事项名称">
                <el-input
                  v-model="form.sxmc"
                  clearable
                  placeholder="请输入事项名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否应急事项">
                <el-select
                  filterable
                  placeholder="是否应急事项"
                  clearable
                  v-model="form.sfyjsx"
                >
                  <el-option
                    v-for="item in sfyjsxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="指标名称">
                <el-input
                  v-model="form.zbmc"
                  clearable
                  placeholder="请输入指标名称"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="考核对象">
                <el-input
                  v-model="form.khdx"
                  clearable
                  placeholder="请输入考核对象（指标类型）"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="启用状态">
                <el-select
                  filterable
                  placeholder="启用状态"
                  clearable
                  v-model="form.state"
                >
                  <el-option
                    v-for="item in sfyjsxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn">
            <div class="select-number">
              当前选中
              <span style="color: #3666EA;">{{
                selectedIdOptions.length
              }}</span>
              条
            </div>
            <el-button
              icon="el-icon-delete"
              class="delbtn"
              type="text"
              @click="delBatchIndexFun"
              >批量删除</el-button
            >
            <el-button type="text" @click="addDialogFun({}, 2)"
              >批量关联点位</el-button
            >
          </div>
          <div class="right-btn">
            <!-- <el-button class="other el-icon-download" @click="downloadFileFun"
              >模板下载</el-button
            >
            <el-upload
              class="upload-demo"
              accept=".xlsx"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="importDataFun"
            >
              <el-button class="other el-icon-upload2">数据导入</el-button>
            </el-upload> -->

            <el-button @click="addDialogFun({}, 1)" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="true"
          :page="page"
          :dataList="dataList"
          :selectedIdOptions="selectedIdOptions"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          @handleSelectionChange="handleSelectionChange"
          @selectAll="selectAll"
        >
          <template v-slot:state="{ scope }">
            <el-switch
              @change="
                value => {
                  changeStateIndexFun(value, scope.row.id);
                }
              "
              v-model="scope.row.state"
              active-value="是"
              inactive-value="否"
              active-color="#0495FF"
            >
            </el-switch>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row, 1)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >详情</el-button
            >
            <el-button
              @click="copyIndexFun(scope.row.id)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >复制</el-button
            >
            <el-button
              @click="delIndexFun(scope.row.id)"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="
        dialogVisible &&
          (curItem.type == 1 || (curItem.type == 2 && selectedIdOptions.length))
      "
      @refreshList="indexPageFun"
      :dialogVisible.sync="dialogVisible"
      :ghEventIndexIdList="selectedIdOptions"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  indexPage,
  selList,
  copyIndex,
  delIndex,
  changeStateIndex,
  delBatchIndex
} from "@/api/base.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
export default {
  components: {
    addDialog,
    commonTable
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      form: {
        ghEventTypeId: "",
        sxmc: "",
        sfyjsx: "",
        zbmc: "",
        khdx: "",
        state: ""
      },
      sfyjsxOptions: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "ghEventTypeSxlx",
            label: "事项类型"
          },
          {
            prop: "ghEventManageSxmc",
            label: "事项名称"
          },
          {
            prop: "zbmc",
            label: "指标名称"
          },
          // {
          //   prop: "fzqz",
          //   label: "指标（分值）权重"
          // },
          // {
          //   prop: "khdx",
          //   label: "考核对象（指标类型）"
          // },
          {
            slot: "state",
            label: "是否启用"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {},
      typeList: []
    };
  },
  mounted() {
    if (this.$route.query) {
      this.form.ghEventTypeId = this.$route.query.ghEventTypeId;
      this.form.sxmc = this.$route.query.sxmc;
    }
    this.selListFun();
    this.indexPageFun();
  },
  methods: {
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    addDialogFun(item, type) {
      if (type == 2 && !this.selectedIdOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择事项指标"
        });
        return;
      }
      this.dialogVisible = true;
      this.curItem = {
        ...item,
        type
      };
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.indexPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.indexPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.indexPageFun();
    },
    onReset() {
      this.form.ghEventTypeId = "";
      this.form.sxmc = "";
      this.form.sfyjsx = "";
      this.form.zbmc = "";
      this.form.khdx = "";
      this.form.state = "";
      this.page.page = 1;
      this.page.size = 10;
      this.indexPageFun();
    },
    async selListFun() {
      const res = await selList({});
      this.typeList = res.data.data || [];
    },
    async copyIndexFun(id) {
      const res = await copyIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delIndexFun(id) {
      const res = await delIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.indexPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delBatchIndexFun(id) {
      const res = await delBatchIndex({
        ids: this.selectedIdOptions
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.onSearch();
        this.selectedIdOptions = [];
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async changeStateIndexFun(value, id) {
      const res = await changeStateIndex({
        id: id,
        state: value
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.indexPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 分页查询
    async indexPageFun() {
      let params = {
        ghEventTypeId: this.form.ghEventTypeId,
        sxmc: this.form.sxmc,
        sfyjsx: this.form.sfyjsx,
        zbmc: this.form.zbmc,
        khdx: this.form.khdx,
        state: this.form.state,
        page: this.page.page,
        size: this.page.size
      };
      const res = await indexPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesStandardManagement/index.vue